import React from "react";
import {handleSlaInputChange} from "../slaCompareEditorUtils";

const MANUAL_SECTIONS = [
    {
        section: "ERROR-REPEAT-COUNT",
        title: "유지보수 서비스 - 장애관리",
        fields: [{target: "countOne", label: "동일장애건수"}],
    },
    {
        section: "REPORT",
        title: "관리서비스 - 적기보고 실시율",
        fields: [
            {target: "countOne", label: "장애 및 이슈 발생건수"},
            {target: "countTwo", label: "적기보고건수"},
        ],
    },
    {
        section: "OUTPUT",
        title: "관리서비스 - 각종 산출물 납기 일정 준수율",
        fields: [
            {target: "countOne", label: "전체 산출물 수"},
            {target: "countTwo", label: "산출물 제출일정 초과 건수"},
        ],
    },
    {
        section: "IMPROVEMENT",
        title: "관리서비스 - 성능개선 제안(건당)",
        fields: [{target: "countOne", label: "성능개선 제안건수"}],
    },
    {
        section: "LEAK",
        title: "관리서비스 - 내부자료 유출 및 중요 데이터 손실(건당)",
        fields: [
            {target: "countOne", label: "내부자료 유출횟수"},
            {target: "countTwo", label: "데이터 소실횟수"},
        ],
    },
];

function ManualCountInput({value, onChange}) {
    return (
        <input
            type="text"
            className="basic-input"
            value={value ?? ""}
            onChange={(e) => {
                const next = e.target.value;
                if (/^\d*$/.test(next)) {
                    onChange(next);
                }
            }}
        />
    );
}

function CompareManualInputView({item, setItem}) {
    return (
        <div className="sla-compare-manual">
            {MANUAL_SECTIONS.map((sectionConfig) => {
                const itemIndex = item.findIndex((row) => row.section === sectionConfig.section);
                if (itemIndex < 0) {
                    return null;
                }

                const row = item[itemIndex];
                const metricRows = sectionConfig.fields.length + 2;
                const rowSpan = metricRows + 1;

                return (
                    <section key={sectionConfig.section} className="sla-compare-manual__section">
                        <h3 className="sla-compare-manual__section-title">{sectionConfig.title}</h3>
                        <div className="sla-compare-modal__table-wrap">
                            <table className="sla-compare-editor-table sla-compare-manual-table w-full">
                                <colgroup>
                                    <col className="sla-compare-manual-col--title"/>
                                    <col className="sla-compare-manual-col--weight"/>
                                    <col className="sla-compare-manual-col--label"/>
                                    <col className="sla-compare-manual-col--value"/>
                                </colgroup>
                                <tbody>
                                <tr>
                                    <th rowSpan={rowSpan} className="fieldset-th">
                                        {row.title}
                                    </th>
                                    <th rowSpan={rowSpan} className="fieldset-th">
                                        가중치({row.weight}%)
                                    </th>
                                </tr>
                                {sectionConfig.fields.map((field) => (
                                    <tr key={field.target}>
                                        <td className="fieldset-td sla-compare-manual-table__label">
                                            {field.label}
                                        </td>
                                        <td className="fieldset-td">
                                            <ManualCountInput
                                                value={row[field.target]}
                                                onChange={(value) => {
                                                    handleSlaInputChange(setItem, value, itemIndex, field.target, "item");
                                                }}
                                            />
                                        </td>
                                    </tr>
                                ))}
                                <tr>
                                    <td className="fieldset-td sla-compare-manual-table__label">평가점수</td>
                                    <td className="fieldset-td sla-compare-manual-table__readonly">
                                        {row.evaluationScore}%
                                    </td>
                                </tr>
                                <tr>
                                    <td className="fieldset-td sla-compare-manual-table__label">환산점수</td>
                                    <td className="fieldset-td sla-compare-manual-table__readonly">
                                        {row.convertedScore}%
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </section>
                );
            })}
        </div>
    );
}

export {CompareManualInputView};
